// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ox6p","content":"styles_content__2VjNW","tableWrap":"styles_tableWrap__38bXX"};